import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts } from 'libs/styles/styling';
import React, { CSSProperties } from 'react';
import styled from 'styled-components/macro';

interface Props {
    icon?: {
        iconSet?: IconPrefix;
        iconName?: IconName;
    };
    title?: string;
    alignment?: 'center' | 'start' | 'end';
    children: React.ReactNode;
    hasBorder?: boolean;
    className?: string;
    style?: CSSProperties;
}

export const SidebarSectionRow = (props: Props): JSX.Element => {
    const hasBorder = props.hasBorder ?? false;

    return (
        <S_SidebarSectionRow className={props.className} $hasBorder={hasBorder}>
            {props.title && (
                <>
                    <S_Left>
                        {props.icon && (
                            <S_Icon icon={[props.icon.iconSet ?? 'fal', props.icon.iconName]} />
                        )}
                        <S_Title>{props.title}</S_Title>
                    </S_Left>
                    <S_Right>{props.children}</S_Right>
                </>
            )}
            {!props.title && <S_FullRow $alignment={props.alignment}>{props.children}</S_FullRow>}
        </S_SidebarSectionRow>
    );
};

const S_SidebarSectionRow = styled.div<{ $hasBorder: boolean }>`
    display: flex;
    color: #141c54;
    border-bottom: ${(props) => (props.$hasBorder ? '1px solid #dadada' : 'none')};
    padding: ${(props) => (props.$hasBorder ? '11px 0' : '0')};
    margin-bottom: ${(props) => (props.$hasBorder ? '5px' : '15px')};
    &:last-of-type {
        border-bottom: none;
        margin-bottom: 0;
    }
`;

const S_FullRow = styled.div<{ $alignment?: Props['alignment'] }>`
    display: flex;
    width: 100%;
    justify-content: ${(props) => props.$alignment ?? 'left'};
`;

const S_Left = styled.div`
    margin: 0 10px 0 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 20px;
    width: 20px;
    margin-right: 15px;
`;

const S_Title = styled.div`
    font-size: 13px;
    font-family: ${EFonts.Regular};
    word-break: break-all;
    user-select: none;
`;

const S_Right = styled.div`
    margin-left: auto;
    display: flex;
    column-gap: 15px;
`;
